import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useContext } from 'react';
import { genStyleUtils } from '@ant-design/cssinjs-utils';
import { ConfigContext } from '../../config-provider/context';
import { genCommonStyle, genLinkStyle } from '../../style';
import useLocalToken, { unitless } from '../useToken';
import useResetIconStyle from './useResetIconStyle';
var _genStyleUtils = genStyleUtils({
    usePrefix: function usePrefix() {
      var _useContext = useContext(ConfigContext),
        getPrefixCls = _useContext.getPrefixCls,
        iconPrefixCls = _useContext.iconPrefixCls;
      var rootPrefixCls = getPrefixCls();
      return {
        rootPrefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls
      };
    },
    useToken: function useToken() {
      var _useLocalToken = useLocalToken(),
        _useLocalToken2 = _slicedToArray(_useLocalToken, 5),
        theme = _useLocalToken2[0],
        realToken = _useLocalToken2[1],
        hashId = _useLocalToken2[2],
        token = _useLocalToken2[3],
        cssVar = _useLocalToken2[4];
      return {
        theme: theme,
        realToken: realToken,
        hashId: hashId,
        token: token,
        cssVar: cssVar
      };
    },
    useCSP: function useCSP() {
      var _useContext2 = useContext(ConfigContext),
        csp = _useContext2.csp,
        iconPrefixCls = _useContext2.iconPrefixCls; // Generate style for icons
      useResetIconStyle(iconPrefixCls, csp);
      return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: function getResetStyles(token) {
      return [{
        '&': genLinkStyle(token)
      }];
    },
    getCommonStyle: genCommonStyle,
    getCompUnitless: function getCompUnitless() {
      return unitless;
    }
  }),
  genStyleHooks = _genStyleUtils.genStyleHooks,
  genComponentStyleHook = _genStyleUtils.genComponentStyleHook,
  genSubStyleComponent = _genStyleUtils.genSubStyleComponent;
export { genStyleHooks, genComponentStyleHook, genSubStyleComponent };